module.exports = __webpack_public_path__ + "static/GrayCzestochowa-8a4f4497d4c52a1d533bb4511f0c45fd.svg";